<a 
    (click)="handleLinkClick()" 
    [class]="customClass" 
    [ngClass]="{active: isActive || isCurrentRoute}"

    >
        {{ text | stripOutTags }}
</a>
